import * as React from 'react'
import cx from 'classnames'
import styles from './FormGroup.m.sass'

export interface FormGroupProps {
  label?: string
  children?: React.ReactNode
  className?: string
  title?: string
  htmlFor?: string
  ['data-test']?: string
}

export default function FormGroup({
  children,
  className,
  label,
  title,
  htmlFor,
  'data-test': dataTest,
}: FormGroupProps) {
  return (
    <div className={cx(styles.formGroup, className)} data-test={dataTest}>
      {label && (
        <label title={title} className={styles.label} htmlFor={htmlFor}>
          {label === ' ' ? <>&nbsp;</> : label}
        </label>
      )}
      {children}
    </div>
  )
}
